import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Profile } from '../Api/Profile';
import { Toast } from '../hooks/useToast';
import { updateKey } from './DefaultReducer';
import CryptoJS from 'crypto-js';

export const postProfileThunk = createAsyncThunk(
    'profile',
    async ({ data, remember_me }, { dispatch }) => {
        Toast("Validating Credentials", "loading", true);
        try {
            const response = await Profile.post(data);
            Toast(response.message, "success", false);
            dispatch(updateKey({ isLoggedIn: true }));
            if (remember_me) {
                const encrypted = CryptoJS.AES
                    .encrypt(JSON.stringify(response.data), process.env.REACT_APP_SECRET_KEY).toString();
                localStorage.setItem("web_token", encrypted);

            }
            return response.data
        } catch (err) {
            Toast(err.message, "error", false);
        }
    }
)

export const postForgetpasswordThunk = createAsyncThunk(
    'profile',
    async ({ email, setLoginForm }, { dispatch }) => {
        Toast("Sending Email", "loading", true);
        try {
            const response = await Profile.postForgetPassword({ email });
            Toast(response.message, "success", false);
            setLoginForm(true);
            return {}
        } catch (err) {
            Toast(err.message, "error", false);
        }
    }
)


const initialState = {
    status: "pending",
    data: {},
}

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        updateKeys: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        },
        resetState: () => {
            return initialState
        }
    },
    extraReducers: {
        [postProfileThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [postProfileThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [postProfileThunk.rejected]: (state, action) => {
            state.status = "error"
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, resetState, updateKeys } = profileSlice.actions

export default profileSlice.reducer